<script setup lang="ts">
// const {appName} = useEnvPaths();
// const {isConsent, sendScreenView} = useAnalytics();
// const {cmsMode} = useCmsStore();
// const consent = useCookie(`${appName()}_cookieConsent`);

//if (import.meta.client) {
const {init} = useCmsStore();
init();
//}
const optanonConsent = useCookie('OptanonConsent');

onMounted(async () => {
  // window.scrollTo(0, 1);

  window.addEventListener('oneTrustCategoriesChanged', (evt) => {
    console.log('Custom event received:', evt.target.OneTrust);

    refreshCookie('OptanonConsent');
    console.log('OptanonConsent cookie:', optanonConsent.value);
  });

  // const {checkGdprLocale} = useGdprStore();
  // checkGdprLocale();

  // isConsent.value = !!consent.value;
  const {renewUserToken} = useAuthStore();
  await renewUserToken();
});

// function onCookieConsentAccepted(): void {
//   isConsent.value = true;
//   consent.value = 'true';
//   sendScreenView({type: 'click', target: 'gdpr-accepted'});
// }
</script>

<template>
  <TheHeader />
  <main class="min-h-screen">
    <NuxtLayout>
      <NuxtErrorBoundary>
        <NuxtPage />
        <template #error="{error}">{{ error }}</template>
      </NuxtErrorBoundary>
    </NuxtLayout>
  </main>

  <TheFooter />
  <!-- <LazyConsentFooter v-if="!isConsent && !cmsMode" role="dialog" @accepted="onCookieConsentAccepted" /> -->
</template>

<style lang="scss">
@media (max-width: 1440px) and (max-height: 810px) {
  html,
  body {
    font-size: 52.5%;
  }
}
</style>
